export default __webpack_public_path__ + "static/media/aws-dynamodb.d520e214.svg";